import * as React from "react";

const LocksetIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      fill="#000"
      d="M19 6.25h-5.25V5c0-2.07-1.68-3.75-3.75-3.75H6C3.93 1.25 2.25 2.93 2.25 5v14c0 2.07 1.68 3.75 3.75 3.75h4c2.07 0 3.75-1.68 3.75-3.75v-7.25H19c1.52 0 2.75-1.23 2.75-2.75S20.52 6.25 19 6.25M12.25 19c0 1.24-1.01 2.25-2.25 2.25H6c-1.24 0-2.25-1.01-2.25-2.25V5c0-1.24 1.01-2.25 2.25-2.25h4c1.24 0 2.25 1.01 2.25 2.25v1.25H9C7.48 6.25 6.25 7.48 6.25 9S7.48 11.75 9 11.75h3.25zM19 10.25H9a1.25 1.25 0 0 1 0-2.5h10a1.25 1.25 0 0 1 0 2.5M8.75 16v2c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-2c0-.41.34-.75.75-.75s.75.34.75.75"
    ></path>
  </svg>
);

export default LocksetIcon;
